module.exports = __webpack_public_path__ + "static/media/test15-rm.ad7b6b00.jpeg";